import { z } from 'zod';
import { tierSchema } from '@forcebase-ai/core';

// src/public.ts
var signupIntentSchema = z.object({
  name: z.string().min(1),
  email: z.string().email(),
  tier: tierSchema.optional()
});
var contactFormSchema = z.object({
  name: z.string().min(1),
  email: z.string().email(),
  message: z.string().min(1).max(2e3)
});
var applicantName = z.string().trim().min(1).max(100);
var doctorApplicationSchema = z.object({
  kind: z.literal("doctor"),
  applicant_email: z.string().trim().email().max(254),
  payload: z.object({
    first_name: applicantName,
    last_name: applicantName,
    npi: z.string().regex(/^\d{10}$/, "NPI must be 10 digits"),
    specialty: z.string().trim().min(1).max(100),
    agreement_accepted: z.literal(true)
  })
});
var fighterApplicationSchema = z.object({
  kind: z.literal("fighter"),
  applicant_email: z.string().trim().email().max(254),
  payload: z.object({
    first_name: applicantName,
    last_name: applicantName
  })
});
var applicationSubmitSchema = z.discriminatedUnion("kind", [
  doctorApplicationSchema,
  fighterApplicationSchema
]);
var applicationResultSchema = z.object({
  id: z.string().uuid(),
  status: z.enum(["submitted", "in_review", "approved", "rejected"]),
  kind: z.enum(["doctor", "fighter"]),
  deduped: z.boolean().optional()
});

export { applicationResultSchema, applicationSubmitSchema, contactFormSchema, doctorApplicationSchema, fighterApplicationSchema, signupIntentSchema };
//# sourceMappingURL=chunk-7SEWNICW.js.map
//# sourceMappingURL=chunk-7SEWNICW.js.map